namespace('arctic.views.groupLanding');

compass.require('compass.hotel.GroupHousingListWidget');

arctic.views.groupLanding.groupMemberRoomAssignment = function(viewport, options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('hotelsView');

	/*
	 * properties.
	 */
	var _viewport = viewport;
	var d = jQuery.dom;
	var $j = jQuery;

	var _groupHousingListWidget;

	var _divs = {};

	var me = this;

	/*
	 * self executing constructor.
	 */
	/*
	 * create the dom nodes of this view.
	 */
	var _render = function(d) {
		_divs.groupLandingRoomAssign = d.div({
			id : "groupLandingRoomAssign",
			className : "groupMemberRoomAssignment"
		});

		_viewport.append(_divs.groupLandingRoomAssign);
	};
	/*
	 * create the variuos widget objects and render their doms.
	 */
	var _setupWidgets = function(viewdata) {
		if(viewdata.reservations.length > 0) {
			_groupHousingListWidget = new compass.hotel.GroupHousingListWidget(_divs.groupLandingRoomAssign, {
				WUID : 'crap',
				groupAvailableHousing : viewdata.reservations,
				meetingInfo : options.meetingInfo,
				hideDistance : viewdata.rules.hideDistance
			});
		}else{
			_divs.groupLandingRoomAssign.append(_drawNoMoreRooms(viewdata.groupContact.primaryContactInfo));
		}
	};
	/*
	 * setup all the controls.
	 */
	var _setupControls = function() {
			$j(_viewport).bind('housingRowClicked', function(evt,data){
				me.navigateToGroupMemberInfo(data);
			});
	};/* end of setup controls. */

	var _drawNoMoreRooms = function(contactInfo) {
		return d.div({className:"noMoreGroupRoomsWrapper"},
				d.div({className:"outOfRoomsMessage"},
					d.p("Oops! This group does not currently have rooms available for assignment."),
					d.p('Please contact your group manager for assistance securing rooms in this group:'),
					d.div({className:"groupContactInfo"},
						d.div({className:"groupContactName"},contactInfo.firstName + " " + contactInfo.lastName),
						d.div({className:"groupContactPhone"},contactInfo.phone),
						d.div({className:"groupContactEmail"},'<a href="mailto:' + contactInfo.email + '">' + contactInfo.email + '</a>')
					)
				)
		);
	};

	this.navigateToGroupMemberInfo = function(args) {
		_viewport.trigger(CompassEvents.Navigate, 'groupMemberInfo/' + [args.blockedRoomId,args.arrive,args.depart].join('/'));
	};

	this.run = function(renderComplete) {
		compass.loading.start();
		jQuery.ajax({
			url : '/groupMemberRoomAssignment',
			success : function(data) {
				compass.loading.stop();
				_render(jQuery.dom);
				// move this into a renderer for testing.
				_setupWidgets(data);
				// draws the widgets and passes any rendering data into them.
				_setupControls();
				// sets up controls on the widgets. setups controls on the view itself.
				
				// stops measuring the time it takes the view to load
				compass.stopLoad('hotelsView');
				renderComplete();
			}
		});
	};
};
